import { DataStore } from "../generic/DataStore";
import { triggerNotification } from "../Notifications";
import { PlayerContextState } from "../PlayerContext";
import { addContextListener } from "../PlayerContextListeners";

export type Help = {
  title: string;
  description: string;
  descriptionWeb?: string;
  order: number;
  isVisible: (state: PlayerContextState) => boolean;
};

const Helps = new DataStore<Help>();

export { Helps };

export function getVisibleHelps(state: PlayerContextState): Help[] {
  return Helps.getAll()
    .filter((help) => help.isVisible(state))
    .sort((a, b) => a.order - b.order);
}

let tempIds: string | undefined = undefined;

addContextListener(
  "HelpNotifier",
  (state) => {
    if (tempIds == null) {
      return;
    }

    const oldIds = tempIds?.split(",") ?? [];
    const newHelps = getVisibleHelps(state);
    for (let help of newHelps) {
      if (!oldIds.includes(help.order.toString())) {
        return (newState) => triggerNotification(newState, "Help", help.title);
      }
    }
  },
  (state, oldValue) => {
    tempIds = oldValue as string | undefined;
    return getVisibleHelps(state)
      .map((help) => help.order.toString())
      .join(",");
  },
);
